<template>
  <div>
    <div v-if="viewMode === 'preview'" class="d-flex align-items-center gap-x-2 p-3 bg-gray-100 rounded-bottom">
      <slot name="preview">
        Preview Here
      </slot>
    </div>
    <slot v-else name="code">
      <div class="d-flex align-items-center gap-x-2 p-3 bg-gray-100">
        <prism-editor
          class="my-editor"
          v-model="codeSample"
          :highlight="highlighter"
          readonly
        ></prism-editor>
      </div>
    </slot>
  </div>
</template>

<script>
 // import highlighting library (you can use any library you want just return html string)
import { PrismEditor } from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css';
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism-dark.css'; // import syntax highlighting styles

export default {
  components: { PrismEditor },
  props: {
    viewMode: {
      type: String,
      default: 'preview'
    },
    codeSample: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      view: 'preview',
    }
  },
  methods: {
    highlighter(code) {
      return highlight(code, languages.js); // languages.<insert language> to return html with markup
    },
  },
}
</script>

<style lang="scss">
.my-editor {
  background: #232e3c;
  font-size: 14px;
  font-family: "SFMono-Regular", Menlo, Monaco, Consolas, "Liberation Mono" ,"Courier New", monospace;
  padding: 1rem;
  border-radius: 4px;
  pre {
    // color: var(--muted) !important;
    // color: white;
    color: var(--muted) !important;
  }
}

// optional
.prism-editor__textarea {
  display: none !important;
}

// not required:
.height-300 {
  height: 300px;
}
</style>